import { Component, OnInit } from '@angular/core';
import { ThemeCustomizerService } from '../theme-customizer/theme-customizer.service';

@Component({
	selector: 'app-trending-categories',
	templateUrl: './trending-categories.component.html',
	styleUrls: ['./trending-categories.component.scss']
})
export class TrendingCategoriesComponent implements OnInit {

	isToggled = false;

    constructor(
        public themeService: ThemeCustomizerService
    ) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

	ngOnInit(): void {}

}